/**
 * @generated SignedSource<<3488495d379528229e5009eade5ee2a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLeadingArticle$data = {
  readonly multimediaEmbed: {
    readonly json: Schema | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeadingImagesContent" | "contentSchemaRenderContent">;
  readonly " $fragmentType": "articleLeadingArticle";
};
export type articleLeadingArticle$key = {
  readonly " $data"?: articleLeadingArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeadingArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLeadingArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "multimediaEmbed",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLeadingImagesContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "bbeade280ee65cf5702e07bba388d7a9";

export default node;
